// extracted by mini-css-extract-plugin
export default {"otp-wrapper":"otpModalBody_otp-wrapper__TNuLV"};